import { render, staticRenderFns } from "./ChatDetail.vue?vue&type=template&id=1c94a8fc"
import script from "./ChatDetail.vue?vue&type=script&lang=js"
export * from "./ChatDetail.vue?vue&type=script&lang=js"
import style0 from "./ChatDetail.vue?vue&type=style&index=0&id=1c94a8fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports